export const getUserInfo = () => {
  if (!window.userData || typeof window.userData !== 'object') {
    return null;
  }

  const { gameAccount, ncAccount, useAccountType } = window.userData || {};
  return useAccountType === 'gameAccount' ? gameAccount : ncAccount;
};

export const getServerId = () => {
  const userInfo = getUserInfo();

  return userInfo?.serverId || 1;
};
